import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Virginia Truffles · Gourmet Delicacies</p>
        <h1>Discover the Rich Flavors of Virginia Truffles</h1>
        <p className="lede">
          Indulge in the exquisite taste of our hand-harvested truffles, sourced from the lush forests of Virginia. Elevate your culinary creations with our premium selection, perfect for any occasion.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Exceptional Quality</h2>
          <p>
            Our truffles are carefully foraged to ensure the highest quality and flavor, bringing a touch of luxury to your dining experience.
          </p>
        </article>
        <article>
          <h2>Versatile Uses</h2>
          <p>
            From gourmet dishes to simple appetizers, our truffles enhance any meal. Explore our recipes and tips to make the most of your purchase.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Sign up for our newsletter to receive exclusive offers, recipes, and updates on our latest truffle harvests.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;